module.exports = __webpack_public_path__ + "static/media/USA-California.be7663b4.jpg";